type Listener = () => void;
const listeners = new Set<Listener>();
let _ready = false;

export function signalAppReady() {
  if (_ready) return;
  _ready = true;
  listeners.forEach((fn) => fn());
  listeners.clear();
}

export function onAppReady(fn: Listener): () => void {
  if (_ready) {
    fn();
    return () => {};
  }
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
}
